import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import BootStrapButton from 'react-bootstrap/Button';

import ModalWrapper from '../../../../../components/RootModal/ModalWrapper';

import * as actions from '../../../../../store/actions';

class BulkNotifyParentModal extends Component {

  handleSubmit = () => {
    this.props.bulkNotifyParentReport(this.props.surveyId);
  }

  render() {
    return (
      <ModalWrapper className='survey-status-modal-wrapper' show={this.props.show} onExited={this.props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Bulk Report Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix='modalContent survey-status-modal'>
          <strong>IMPORTANT: This action will email/text all the contacts associated with this survey.</strong> <br />  
          <strong>This action can not be undone.</strong>
          <div className="btnContainer-edit-participant">
          <BootStrapButton
            onClick={() => this.handleSubmit()}
            type="submit"
            className="modalBtn"
            size="lg"
            variant="danger"
          >
            Send Notification
          </BootStrapButton>
          <BootStrapButton onClick={this.props.closeModal} className="modalBtn" size="lg" variant="outline-primary">
            Cancel
          </BootStrapButton>
        </div>
        </Modal.Body>
      </ModalWrapper>
    );
  }
}


const mapDispatchToProps = dispatch => {
  return {
    bulkNotifyParentReport: (surveyId) => dispatch(actions.bulkNotifyParentReport(surveyId)),
    closeModal: () => dispatch(actions.closeModal()),
  };
};


export default connect(null,mapDispatchToProps)(BulkNotifyParentModal);
